import React, { useState } from 'react'
import {
    Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure, useToast
} from '@chakra-ui/react'
import { useAdminContextModalStore } from '../../store/modalsStore'
import UmSpinner from '../UI/UmSpinner'
import ContextCard from '../ContextCard/ContextCard'
import AdminService from '../../API/AdminService'
import AdminAddContextModal from './AdminAddContextModal'
import { useAdminStore } from '../../store/adminStore'

function AdminContextModal({isOpen, onClose}) {
    const modalUser = useAdminContextModalStore(state => state.modalUser)
    const setModalUser = useAdminContextModalStore(state => state.setModalUser)
    const [selectedContext, setSelectedContext] = useState(null)
    const toast = useToast()
    const addContextDisclsure = useDisclosure()
    const contextsPagePaginationData = useAdminStore(state => state.contextsPagePaginationData)
    const setContextsPagePaginationData = useAdminStore(state => state.setContextsPagePaginationData)

    const clearAndClose = () => {
        setModalUser(null)
        setSelectedContext(null)
        onClose()
    }

    const deleteContext = () => {
        toast.promise(
            AdminService.deleteContext(modalUser.id, selectedContext?.id),
            {
                success: () => {
                    setModalUser({...modalUser, contexts: modalUser.contexts.filter(c => c.id !== selectedContext.id)})
                    setContextsPagePaginationData({...contextsPagePaginationData, results: contextsPagePaginationData.results.map(user => {
                        if (user.id === modalUser.id) {
                            return {...user, contexts: user.contexts.filter(c => c.id !== selectedContext?.id)}
                        }
                        return user
                    })})
                    return { title: 'Контект удалён' }
                },
                error: (e) => {
                    console.log(e)
                    return { title: 'Не удалось удалить контекст' }
                },
                loading: { title: 'Удаление контекста', description: 'Подождите', position: 'top' },
            }
        )
    }

    return (
        <Modal isOpen={isOpen} onClose={clearAndClose} size='2xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Изменение контекстов</ModalHeader>
                <ModalCloseButton onClick={clearAndClose} />
                <ModalBody>
                    {
                    !modalUser
                    ?
                    <UmSpinner />
                    :
                    <>
                        <AdminAddContextModal
                            isOpen={addContextDisclsure.isOpen}
                            onClose={addContextDisclsure.onClose}
                        />
                        <Flex justifyContent='space-between' marginBottom='10px'>
                            <Button
                                size='sm'
                                onClick={() => addContextDisclsure.onOpen()}
                            >
                                Добавить новый
                            </Button>
                            <Button
                                size='sm'
                                disabled={!selectedContext}
                                onClick={deleteContext}
                            >
                                Удалить
                            </Button>
                        </Flex>
                        {modalUser.contexts.map(c => (
                            <ContextCard
                                context={c}
                                selected={selectedContext && selectedContext.id === c.id}
                                key={`admin-contexts-${modalUser.id}-${c.id}`}
                                onClick={() => setSelectedContext(c)}
                            />
                        ))}
                    </>
                    }
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default AdminContextModal
